'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=require('./createColorPalette'),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var red={1:'#fff2f4',2:'#ffe1e6',3:'#fabcc5',4:'#f78394',5:'#ed596f',6:'#e71d3a',7:'#d21c35',8:'#a9172c',9:'#7e1021',10:'#5c0c18',inflection:6};exports.default=(0,_createColorPalette2.default)(red,'red');


/** WEBPACK FOOTER **
 ** ./~/@vitalsource/vstui/colors/red.js
 **/